import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

let toggleGroupCounter = 0;

@Component({
  selector: 'doc-custom-toggle',
  standalone: true,
  imports: [CommonModule],
  template: `
    <label
      class="doc-custom-toggle"
      [class.reverse-switch]="reverseSwitch"
      [class.disabled]="disabled"
      [class.checked]="checked"
      (click)="onToggle($event)">
      <input
        type="radio"
        class="doc-custom-toggle-input"
        [attr.name]="groupName"
        [attr.id]="inputId ? inputId + '-off' : null"
        [checked]="!checked"
        [disabled]="disabled"
        tabindex="-1"
        aria-hidden="true" />
      <input
        type="radio"
        class="doc-custom-toggle-input"
        [attr.name]="groupName"
        [attr.id]="inputId || null"
        [checked]="checked"
        [disabled]="disabled"
        tabindex="-1"
        [attr.aria-checked]="checked" />
      <span class="doc-custom-toggle-slider" aria-hidden="true"></span>
    </label>
  `,
  styleUrl: './doc-custom-toggle.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DocCustomToggleComponent),
      multi: true,
    }],
})
export class DocCustomToggleComponent implements ControlValueAccessor {
  @Input() inputId = '';
  @Input() reverseSwitch = false;

  readonly groupName = `doc-custom-toggle-${++toggleGroupCounter}`;

  checked = false;
  disabled = false;

  onToggle(event: MouseEvent): void {
    if (this.disabled) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    this.setChecked(!this.checked);
  }

  private setChecked(value: boolean): void {
    if (this.checked === value) {
      return;
    }

    this.checked = value;
    this.onChange(value);
    this.onTouched();
  }

  private onChange: (value: boolean) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  writeValue(value: unknown): void {
    this.checked = value === true;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
